module.exports = {
      id: "arcade-usage",
      viewBox: "0 0 19.915 20.731",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#arcade",
      toString: function () {
        return this.url;
      }
    }